import React from 'react';
import MemberCard from "./MemberCard.js";

const PlayerMemberList = ({members, type, printAble, childrenAndMember,admin}) => {
  const memberCard = members[0].map(member => <MemberCard key={member.id} member={member} positions={members[1]} canEdit={admin || childrenAndMember.includes(member.user_id)} />);
  return (
    <>
      <section className="SectionContainer shadow-sm">
        <header className="SectionHeader d-flex justify-content-between align-items-center">
            <h1>
              {type.toUpperCase()}
              <span className="ms-1">
                {
                  admin && `(${members[0].length})` /// ${members[0].length} )`
                }
              </span>
            </h1>
          <div className="text-end px-1" style={{marginInlineStart: "auto"}}>
            <a href={printAble}>
              <i className="fa-solid fa-print"></i>
              <span className="ms-1">Printable</span>
            </a>
          </div>
        </header>
        <div className="SectionBody position-relative">
          <div className="container u-borderBottom">
            {memberCard.length === 0  && <p className="text-center fst-italic m-0 p-4">There are no Players</p> }
            <ul className={`row p-0 ${memberCard.length > 0 && "pb-2"} m-0 list-unstyled`}>
              {memberCard}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default PlayerMemberList;
